<template>
  <div
    class="siri-wave"
    ref="siriContainer"
    :style="{left: containerWidth / 2 + containerHeight / 2 + 'px'}"
  ></div>
</template>

<script>
import SiriWave from "siriwave";
export default {
  props: ["audioPlay"],
  watch: {
    audioPlay(audioPlay) {
      if (this.siriWave) {
        if (audioPlay) {
          this.siriWave.setAmplitude(0.7);
          // this.siriWave.start();
        } else {
          this.siriWave.setAmplitude(0.001);
          // setTimeout(() => {
          //   this.siriWave.stop();
          // }, 1000);
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      let container = this.$refs.siriContainer.getBoundingClientRect();
      this.containerWidth = container.width;
      this.containerHeight = container.height;

      this.siriWave = new SiriWave({
        container: this.$refs.siriContainer,
        width: container.width,
        height: container.width,
        color: "#fed300",
        autostart: true,
        amplitude: 0.0
      });
    });
  },
  data() {
    return {
      siriWave: null,
      containerWidth: 0,
      containerHeight: 0
    };
  }
};
</script>

<style lang="scss" scoped>
.siri-wave {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  transform: rotate(90deg) translateY(5px);
  transform-origin: 0 0;
}
</style>
